import { defineStore } from 'pinia';

interface SystemState {
  isMobile: boolean,
}

export const useSystemStore = defineStore('System', {
  state: (): SystemState => ({
    isMobile: false
  }),
  actions: {
    setDeviceType(type: boolean) {
      this.isMobile = type;
    },
    nuxtServerInit({ req }: { req: any }) {
      const userAgent = req.headers['user-agent'] || '';
      console.log('userAgent', userAgent);
      const isMobile = /mobile|android|iphone|ipad/i.test(userAgent.toLowerCase());
      this.setDeviceType(isMobile);
    }
  },
  persist: {
    enabled: true,
    strategies: [
      // { storage: sessionStorage, paths: ['firstName', 'lastName'] },
      { key: 'SystemStore' }
    ]
  }
});
